<!--
 * @Author: chenx
 * @CreatedDate: Do not edit
 * @LastEditTime: 2021-04-12 10:18:24
 * @Description: 人气工队
-->
<template>
  <div :style="{paddingTop: top?'10px':0}">
    <ScreenSort @changeobj="changeobj" :config="['teamType','secondCategory','locationAddress']" :teamSizeType="params.teamType" :secondCategoryi="3"></ScreenSort>
    <!-- 列表 -->
    <div class="table" v-loading="loadingTrue">
      <div style="padding: 0 20px 10px 20px">
        <el-row :gutter="20" v-if="list.length">
          <el-col v-for="(item, index) in list" :key="index" :span="12">
            <card :item="item" :type="1" :index="index" :showIndex="param.page==1" :cardType="2"></card>
          </el-col>
          <template>
            <el-col :span="24" class="course-loading-wrap" v-show="moreLoading">
              数据加载中... <i class="el-icon-loading loading-icon"></i>
            </el-col>
            <el-col :span="24" class="course-loading-wrap" v-show="!moreLoading && nomore">没有更多数据了!</el-col>
          </template>
        </el-row>

        <div v-if="!list.length && !loadingTrue" style="width: 1200px; margin: 0 auto; margin-bottom: 10px">
          <BaseEmptyData></BaseEmptyData>
        </div>
      </div>
    </div>


    <!-- <Pagination
      v-if="param.total&&!loadingTrue"
      :param="param"
      :loadingTrue="loadingTrue"
      @change="getList"
    ></Pagination> -->
  </div>
</template>
<script>
import { apiPopularityTeam } from "@/api/apiPopularityTeam"
const throttle = require("lodash/throttle");
export default {
  components: {
    ScreenSort: () =>import("@/components/screenSort/screenSort"),
    card:() =>import("@/components/card/cardTeam"),
    Pagination: () => import("@/components/card/page"),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
  },
  props: {
    top: {
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      list: [],
      loadingTrue: true,
      moreLoading: false, //加载更多
      nomore: false, //没有数据显示
      params: {},
      param: {
        page: 1,
        limit: 40,
        total: 0,
        totalPages: 0
      },
    }
  },
   watch: {
    // 页数改变的时候
    "param.page": {
      handler(val) {
        if (val > this.param.totalPages) {
          this.nomore = true;
        } else {
          this.nomore = false;
        }
      },
    },
   },
  methods: {
    //获取列表数据
    async listFun() {
      this.moreLoading = true //加载更多显示
      let params={...this.params}
      params.page=this.param.page
      params.limit=this.param.limit
      let res = await apiPopularityTeam.getTeamPopular(params)
      this.loadingTrue = false //初次进来页面加载状态隐藏
      if (res && res.data.code === 200) {
        this.param.total=res.data.data.total;
        this.param.totalPages=res.data.data.pages;
        this.list = [...this.list,...res.data.data.records]
        this.moreLoading = false //加载更多隐藏

      }
    },
     // 页面滚动
    windowScroll: throttle(
      function () {
        // 如果当前页数大于总页数 则不去获取
        let scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        let clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        /**
         * clientHeight 视口大小
         * scrollHeight 文档高度
         */
        if (scrollTop + clientHeight >= scrollHeight - 300) {
          this.param.page += 1;
          if (this.param.page <= this.param.totalPages) {
            this.listFun()
          }
        }
      },
      1500,
      { leading: false, trailing: true }
    ),
    //获取组件中参数
    changeobj(obj){
      //清空参数
      for(let i in this.params){
        this.params[i]=''
      }
      //重置参数
      this.param.page=1
      this.list=[]
      this.loadingTrue=true
      //获取所在地区
      this.params.provinceNo=obj.locationAddresscode.provinceId;
      this.params.cityNo=obj.locationAddress?obj.locationAddresscode.cityId:'';
      this.params.areaNoList=obj.locationAddress?obj.locationAddress.map(v=>{return v.no}):[];
      if(obj.locationAddresscode.isAll){
        this.params.areaNoList=this.params.areaNoList[0]
      }
      //获取工程分类
      let t=this;
      ['firstCategoryNo','secondCategoryNo','thirdCategoryNo','fourCategoryNo','fifthCategoryNo','sixthCategoryNo'].forEach((v,i)=>{
        if(obj.secondCategory){
          t.params[v]=obj.secondCategory[i]?obj.secondCategory[i].no:''
        }else{
          t.params[v]=''
        }
      })
      //获取团队类型
      this.params.teamType=obj.teamType&&obj.teamType[0]?obj.teamType[0].no:''
      this.params.teamNumber=obj.teamSize&&obj.teamSize[0]?obj.teamSize[0].ranges:''
      this.loadingTrue=true //页面初始加载状态显示
      this.getList();
    },
    getList(){
      this.params.page=1
      this.list = []
      this.loadingTrue = true
      this.listFun()
    }
  },
  mounted(){
    document.addEventListener("scroll", this.windowScroll);
  },
   beforeDestroy() {
    document.removeEventListener("scroll", this.windowScroll);
  },
  provide(){
    return {
      cardListCom:this
    }
  }
}
</script>
<style lang="scss" scoped>
.table {
  position: relative;
  width: 1200px;
  margin: 10px auto 0;
  overflow: hidden;
  min-height: 400px;
  background: white;
  border: 1px solid #e4e7ed;
}
.course-loading-wrap {
    display: flex;
    padding-top: 10px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    color: #999;
    background: #fff;
    .loading-icon {
      margin-left: 12px;
      font-size: 24px;
    }
  }
</style>
